import React, { useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormHelperText,
  Stack,
  styled,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

import OnboardingContainer from '../../Component/OnboardingContainer';
import { ScreenBackV2WithTitle } from '../../../Components/ScreenBackV2';
import {
  validateIsAlphaNumeric,
} from '../../../Utils';
import { GetMeAction, getGstDetails, getPanDetails } from '../../auth/action';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  '&.Mui-selected': {
    backgroundColor: 'white',
    color: 'black',
    '&:hover': {
      backgroundColor: 'lightgray',
    },
  },
  '&:not(.Mui-selected)': {
    backgroundColor: 'gray',
    color: 'white',
    '&:hover': {
      backgroundColor: 'lightgray',
    },
  },
}));

const toggleButtonlist = [
  {
    value: 'GSTIN',
    label: 'GSTIN',
  },
  {
    value: 'PAN',
    label: 'PAN',
  },
];

const FetchFirmDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const onSubmit = async () => {
    setLoading(true);
    const newErrors = {};
    if (!inputValue) {
      newErrors.gstPan = 'Enter GSTIN or PAN Number';
    }
    if (!validateIsAlphaNumeric(inputValue) && alignment === 'GSTIN')
      newErrors.gstPan = 'Enter a valid GSTIN number';

    if (!validateIsAlphaNumeric(inputValue) && alignment === 'PAN')
      newErrors.gstPan = 'Enter a valid PAN number';

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return setLoading(false);
    }

    const onSuccessNavigate = (data) => {
      setLoading(false);
      navigate('/FirmOnboarding', { state: { data: data } });
    };

    const onGstSuccess = async () => {
      const { data, error, message } = await getGstDetails(inputValue);
      setLoading(false);

      if (!error) onSuccessNavigate(data);
      else return toast.error(message);
    };

    const onPanSuccess = async () => {
      const { data, error, message } = await getPanDetails(inputValue);
      setLoading(false);

      if (!error) onSuccessNavigate(data);
      else return toast.error(message);
    };

    if (inputValue.length === 15 && alignment === 'GSTIN') {
      return await onGstSuccess();
    } else if (inputValue.length === 10 && alignment === 'PAN') {
      return await onPanSuccess();
    }
    setLoading(false);
  };

  const onSkip = async () => {
    const { error: userError, data: loggedInUser } = await GetMeAction();

    if (!userError && loggedInUser) {
      dispatch({ type: 'SET_USER', data: loggedInUser });

      navigate('/');
    }
  };
  const [alignment, setAlignment] = useState(toggleButtonlist[0].value);

  const handleAlignment = (event, newAlignment) => {
    if (newAlignment !== null) {
      setInputValue('');
      setErrors({});
      setAlignment(newAlignment);
    }
  };

  return (
    <OnboardingContainer>
      <ScreenBackV2WithTitle
        title={'Firm Onboarding'}
        action={
          <Button
            variant='outlined'
            color='primary'
            onClick={() => onSkip()}
          >
            Skip
          </Button>
        }
        handleBackClick={() => onSkip()}
      />
      {loading ? (
        <Stack
          sx={{ pl: '2rem', mt: '2rem' }}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <CircularProgress color='secondary' />
        </Stack>
      ) : (
        <Stack
          sx={{ mt: '2rem' }}
          direction={'row'}
          spacing={6}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <FormControl
            sx={{ width: '90%' }}
            margin='normal'
            error={!!errors.gstPan}
          >
            <TextField
              className='darkBackground'
              margin='normal'
              required
              fullWidth
              id='gstPan'
              label={`Enter ${alignment} Number`}
              name='gstPan'
              autoFocus
              color='secondary'
              value={inputValue}
              onChange={(e) => {
                const value = e.target.value.toUpperCase();
                if (value === '' || validateIsAlphaNumeric(value)) {
                  setInputValue(value);
                }
              }}
              inputProps={{
                style: { textTransform: 'uppercase' },
                maxLength: alignment === 'GSTIN' ? 15 : 10,
              }}
            />
            {errors.gstPan && <FormHelperText>{errors.gstPan}</FormHelperText>}
          </FormControl>
          <ToggleButtonGroup
            value={alignment}
            exclusive
            onChange={handleAlignment}
            aria-label='text alignment'
          >
            {toggleButtonlist.map((toggleButton) => (
              <StyledToggleButton
                value={toggleButton.value}
                aria-label={toggleButton.value}
              >
                {toggleButton.label}
              </StyledToggleButton>
            ))}
          </ToggleButtonGroup>
        </Stack>
      )}
      <Box sx={{ mt: '3rem' }}>
        <Button
          onClick={onSubmit}
          variant='contained'
          color='primary'
          fullWidth
        >
          Verify
        </Button>
      </Box>
    </OnboardingContainer>
  );
};

export default FetchFirmDetail;
